import { cls } from 'constants/cls';

export const getUserUref = (userId: string | null): string | undefined => {
  if (!userId) return;
  return `${cls.user}:${userId}`;
};

export const getInitialsFromFullname = (fullName?: string): string => {
  if (!fullName) {
    return '';
  }

  return fullName
    .split(' ')
    .map((part) => part[0])
    .join('');
};
